export function getView(data) {
  if (data.type === 'chairTemplate') {
    return 'OverrideChairSchedule'
  }

  return 'ScheduleNote'
}
